import React from 'react';

const PermissionsEmployeeTable = ({
  title,
  permissions,
  activePermissions = [],
  permissionsDetailed = [],
  onToggle = () => {},
  mode = 'view',
  prefix = '',
}) => { 
  return (
    <fieldset>
      <div className="mt-4 divide-y divide-gray-200 border-b border-t border-gray-200">
        <div className="grid grid-cols-5 gap-4 px-2 py-2 font-medium text-gray-600 bg-gray-50">
          <div className="col-span-3 text-lg font-bold text-indigo-800">{title}</div>
          {mode === 'edit' ? (
            <>
              <div className="text-center text-sm col-span-1">Attiva sul dipendente</div>
              <div className="text-center text-sm col-span-1">Permesso attivo per Unità/Azienda</div>
            </>
          ) : (
            <div className="text-center text-gray-700 mt-1 items-center text-sm col-span-2">Assegnato da</div>
          )}
        </div>

        {permissions && permissions?.length > 0 ? (
          permissions.map((permission) => (
            <div key={permission.id} className="grid grid-cols-5 gap-4 items-center px-2 py-2">
              <div className="text-normal text-gray-900 col-span-3">{permission?.name}</div>
              
              {mode === 'edit' && (
                <div className="text-center text-sm col-span-1">
                  <input
                    id={`${prefix}-permission-${permission.id}`}
                    type="checkbox"
                    className="h-5 w-5 rounded text-indigo-600 focus:ring-indigo-600"
                    checked={activePermissions.includes(permission.codename)}
                    onChange={(e) => onToggle(permission.id, e.target.checked)}
                  />
                </div>
              )}

              <div className={`flex items-center justify-center text-sm ${mode === 'edit' ? 'col-span-1' : 'col-span-2'}`}>
                {(() => {
                  const found = permissionsDetailed.find(p => p.codename === permission.codename);

                  return (
                    <div className="col-span-1 flex items-center justify-center h-full w-full">
                      <span className="max-w-full truncate text-center text-sm font-semibold text-indigo-600">
                        {mode && mode == 'edit' ? (
                          <>
                            {found?.comes_from === 'company'
                              ? 'Azienda'
                              : found?.comes_from === 'ou'
                              ? 'Unità organizzativa'
                              : found?.comes_from === 'employee'
                              ? ''
                              : ''}
                          </>
                        ) : (
                          <>
                            {found?.comes_from === 'company'
                              ? 'Azienda'
                              : found?.comes_from === 'ou'
                              ? 'Unità organizzativa'
                              : found?.comes_from === 'employee'
                              ? 'Dipendente'
                              : ''}
                          </> 
                        )}
                      </span>
                    </div>
                  );
                })()}
              </div>
            </div>
          ))
        ) : (
          <div className="text-gray-500 px-2 py-4">Nessuna autorizzazione disponibile per {title.toLowerCase()}</div>
        )}
      </div>
    </fieldset>
  );
};

export default PermissionsEmployeeTable;
